import type { GqlGqlActionType } from '@app-types/index';

import type {
  ActionTypeBadgeConfig,
  SessionStatus,
  StatusConfig,
  Suggestion,
} from './types';

/**
 * Get status configuration for session status icon
 */
export const getStatusConfig = (status?: SessionStatus): StatusConfig => {
  // Theme tokens (not raw hex) so status badges adapt in dark mode.
  switch (status) {
    case 'PROCESSING':
      return {
        color: 'var(--badge-blue-fg)',
        bgColor: 'var(--badge-blue-bg)',
        icon: 'spinner',
        title: 'Processing',
      };
    case 'WAITING_FOR_USER':
      return {
        color: 'var(--badge-amber-fg)',
        bgColor: 'var(--badge-amber-bg)',
        icon: 'question',
        title: 'Waiting for response',
      };
    case 'ERROR':
      return {
        color: 'var(--badge-red-fg)',
        bgColor: 'var(--badge-red-bg)',
        icon: 'error',
        title: 'Error',
      };
    case 'CANCELLED':
      return {
        color: 'var(--marble-bg-600)',
        bgColor: 'var(--marble-bg-100)',
        icon: 'cancelled',
        title: 'Cancelled',
      };
    case 'COMPLETED':
    default:
      return {
        color: 'var(--badge-green-fg)',
        bgColor: 'var(--badge-green-bg)',
        icon: 'check',
        title: 'Completed',
      };
  }
};

/**
 * Get action type badge configuration
 */
export const getActionTypeBadgeConfig = (
  actionType?: GqlGqlActionType | null,
): ActionTypeBadgeConfig | null => {
  switch (actionType) {
    case 'CREATE':
      return {
        label: 'Create',
        color: 'var(--badge-green-fg)',
        bgColor: 'var(--badge-green-bg)',
      };
    case 'UPDATE':
      return {
        label: 'Update',
        color: 'var(--badge-blue-fg)',
        bgColor: 'var(--badge-blue-bg)',
      };
    case 'DELETE':
      return {
        label: 'Delete',
        color: 'var(--badge-red-fg)',
        bgColor: 'var(--badge-red-bg)',
      };
    case 'SEARCH':
      return {
        label: 'Search',
        color: 'var(--badge-purple-fg)',
        bgColor: 'var(--badge-purple-bg)',
      };
    default:
      return null;
  }
};

/**
 * Default suggestions for new chat sessions
 */
export const DEFAULT_SUGGESTIONS: Suggestion[] = [
  { text: 'Tell me about the app', color: 'var(--badge-blue-bg)' },
  { text: 'Find influencers', color: 'var(--badge-pink-bg)' },
  { text: 'Create a list', color: 'var(--badge-amber-bg)' },
  { text: 'Create a campaign', color: 'var(--badge-green-bg)' },
];

export const CREATOR_SUGGESTIONS: Suggestion[] = [
  { text: 'Tell me about the app', color: 'var(--badge-blue-bg)' },
];
